const initialState = { processorTerminalsData: [], processorTerminalData: [], terminalBatchData: [], cassetteData: [], filteredData: [], edited: false, processorTerminalID: null, isExist: false, modified: false, isSerial: false, loadingBatchData: false, keysData: [], clone: false };

export const PROCESSORTERMINALREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_PROCESSOR_TERMINALS':
            return {
                ...state,
                processorTerminalsData: action.data,
            }
        case 'GET_PROCESSOR_TERMINAL_DATA':
            return {
                ...state,
                processorTerminalData: action.data,
            }
        case 'FILTER_PROCESSOR_TERMINALS':
            return {
                ...state,
                filteredData: action.data
            }
        case 'SET_EDIT':
            return {
                ...state,
                edited: action.data
            }
        case 'SET_PROCESSOR_TERM_ID':
            return {
                ...state,
                processorTerminalID: action.data
            }
        case 'SET_EXIST':
            return {
                ...state,
                isExist: action.data
            }
        case 'SET_MODIFIED':
            return {
                ...state,
                modified: action.data
            }
        case 'SET_PROCESSOR_BATCH_DATA':
            return {
                ...state,
                terminalBatchData: action.data
            }
        case 'SET_CASSETTE_DATA':
            return {
                ...state,
                cassetteData: action.data
            }
        case 'LOADING_BATCH_DATA':
            return {
                ...state,
                loadingBatchData: action.data
            }
        case 'KEYS_DATA':
            return {
                ...state,
                keysData: action.data
            }
        case 'SET_CLONE':
            return {
                ...state,
                clone: action.data
            }
        default:
            return state;
    }
}